import React from 'react'

import { Box, Typography } from "@mui/material"
import { formatDate } from "@ui-seeker/utils"
import { dateFormatReceiver } from "@utils"


export default function datesColumn() {

	return {
		name: 'bookingDate',
		label: 'Date',
		options: {
			customBodyRowRenderLite: value => <Box>
				<Typography>{formatDate(value, {
					isString: true,
					receivedFormat: dateFormatReceiver(value)
				})}</Typography>
			</Box>
		}
		,
	}
}